/**
 * Application Router Configuration
 * Defines all routes and navigation
 */
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Layout } from '../components/layout';
import Home from '../pages/Home';
import HouseLoanPage from '../pages/calculators/HouseLoanPage';
import PartialRepaymentPage from '../pages/calculators/PartialRepaymentPage';
import LoanAffordabilityPage from '../pages/calculators/LoanAffordabilityPage';
import RentVsBuyPage from '../pages/calculators/RentVsBuyPage';
import SavingsGoalPage from '../pages/calculators/SavingsGoalPage';
import InvestmentReturnPage from '../pages/calculators/InvestmentReturnPage';
import RetirementPlanningPage from '../pages/calculators/RetirementPlanningPage';
import DebtPayoffPage from '../pages/calculators/DebtPayoffPage';
import CreditCardPayoffPage from '../pages/calculators/CreditCardPayoffPage';
import Privacy from '../pages/Privacy';
import Terms from '../pages/Terms';
import Contact from '../pages/Contact';
import About from '../pages/About';
import Blog from '../pages/Blog';
import BlogPost1 from '../pages/BlogPost1';
import BlogPost2 from '../pages/BlogPost2';
import BlogPost3 from '../pages/BlogPost3';
import BlogPost4 from '../pages/BlogPost4';
import BlogPost5 from '../pages/BlogPost5';
import BlogPost6 from '../pages/BlogPost6';
import BlogPost7 from '../pages/BlogPost7';
import BlogPost8 from '../pages/BlogPost8';
import BlogPost9 from '../pages/BlogPost9';
import BlogPost10 from '../pages/BlogPost10';
import BlogPost11 from '../pages/BlogPost11';
import BlogPost12 from '../pages/BlogPost12';
import BlogPost13 from '../pages/BlogPost13';
import BlogPost14 from '../pages/BlogPost14';
import BlogPost15 from '../pages/BlogPost15';
import BlogPost16 from '../pages/BlogPost16';
import BlogPost17 from '../pages/BlogPost17';
import BlogPost18 from '../pages/BlogPost18';
import BlogPost19 from '../pages/BlogPost19';
import BlogPost20 from '../pages/BlogPost20';
import BlogPost21 from '../pages/BlogPost21';
import BlogPost22 from '../pages/BlogPost22';
import BlogPost23 from '../pages/BlogPost23';
import BlogPost24 from '../pages/BlogPost24';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'calculators/house-loan',
        element: <HouseLoanPage />,
      },
      {
        path: 'calculators/partial-repayment',
        element: <PartialRepaymentPage />,
      },
      {
        path: 'calculators/loan-affordability',
        element: <LoanAffordabilityPage />,
      },
      {
        path: 'calculators/rent-vs-buy',
        element: <RentVsBuyPage />,
      },
      {
        path: 'calculators/savings-goal',
        element: <SavingsGoalPage />,
      },
      {
        path: 'calculators/investment-return',
        element: <InvestmentReturnPage />,
      },
      {
        path: 'calculators/retirement-planning',
        element: <RetirementPlanningPage />,
      },
      {
        path: 'calculators/debt-payoff',
        element: <DebtPayoffPage />,
      },
      {
        path: 'calculators/credit-card-payoff',
        element: <CreditCardPayoffPage />,
      },
      {
        path: 'privacy',
        element: <Privacy />,
      },
      {
        path: 'terms',
        element: <Terms />,
      },
      {
        path: 'contact',
        element: <Contact />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: 'blog',
        element: <Blog />,
      },
      {
        path: 'blog/2026-hong-kong-best-mortgage-rates',
        element: <BlogPost1 />,
      },
      {
        path: 'blog/should-you-make-partial-mortgage-repayments-hk-2026',
        element: <BlogPost2 />,
      },
      {
        path: 'blog/first-time-homebuyer-mortgage-guide-2026',
        element: <BlogPost3 />,
      },
      {
        path: 'blog/true-cost-5-million-mortgage-hong-kong-2026',
        element: <BlogPost4 />,
      },
      {
        path: 'blog/fixed-vs-floating-rate-mortgages-hong-kong-2026',
        element: <BlogPost5 />,
      },
      {
        path: 'blog/gold-silver-investment-investigation-2026',
        element: <BlogPost6 />,
      },
      {
        path: 'blog/5-essential-financial-planning-steps-hong-kong-2026',
        element: <BlogPost7 />,
      },
      {
        path: 'blog/hong-kong-fixed-deposit-rates-comparison-february-2026',
        element: <BlogPost8 />,
      },
      {
        path: 'blog/best-virtual-banks-hong-kong-2026',
        element: <BlogPost9 />,
      },
      {
        path: 'blog/2026-personal-finance-planning-guide',
        element: <BlogPost10 />,
      },
      {
        path: 'blog/emergency-fund-hong-kong-2026',
        element: <BlogPost11 />,
      },
      {
        path: 'blog/credit-card-debt-management-hong-kong-2026',
        element: <BlogPost12 />,
      },
      {
        path: 'blog/mpf-maximization-retirement-planning-hong-kong-2026',
        element: <BlogPost13 />,
      },
      {
        path: 'blog/mortgage-refinancing-hong-kong-2026',
        element: <BlogPost14 />,
      },
      {
        path: 'blog/rent-vs-buy-hong-kong-2026',
        element: <BlogPost15 />,
      },
      {
        path: 'blog/hong-kong-stamp-duty-guide-2026',
        element: <BlogPost16 />,
      },
      {
        path: 'blog/hos-mortgage-guide-hong-kong-2026',
        element: <BlogPost17 />,
      },
      {
        path: 'blog/how-to-read-mortgage-statement-hong-kong',
        element: <BlogPost18 />,
      },
      {
        path: 'blog/effective-interest-rate-vs-flat-rate-hong-kong',
        element: <BlogPost19 />,
      },
      {
        path: 'blog/emergency-fund-how-much-hong-kong',
        element: <BlogPost20 />,
      },
      {
        path: 'blog/5-mortgage-mistakes-first-time-buyers-hong-kong',
        element: <BlogPost21 />,
      },
      {
        path: 'blog/hong-kong-mortgage-amortization-explained',
        element: <BlogPost22 />,
      },
      {
        path: 'blog/how-much-can-you-borrow-hk10000-monthly-mortgage',
        element: <BlogPost23 />,
      },
      {
        path: 'blog/shorter-vs-longer-mortgage-term-hong-kong',
        element: <BlogPost24 />,
      },
    ],
  },
]);

export default function Router() {
  return <RouterProvider router={router} />;
}
